import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import "bootstrap/dist/css/bootstrap.min.css"; 
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; 
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; 
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx'; 
import Header from '../Header';

const AssigningTickets = () => {
  const [tickets, setTickets] = useState([]);
  const [employees, setEmployees] = useState([]);  // State for employees
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null); // Track the selected ticket for updating status
  const [transferTicket, setTransferTicket] = useState(null); // State for transfer modal
  const [selectedEmployee, setSelectedEmployee] = useState('');  // Track selected employee for transfer
  const [remarks, setRemarks] = useState('');  // Track remarks for ticket transfer
  const [successMessage, setSuccessMessage] = useState(null);
  const tableRef = useRef(null);
  const id = localStorage.getItem('userId');
  const navigate = useNavigate();

  

  // Fetch tickets data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Fetch both tickets and employees concurrently
        const [ticketResponse, employeeResponse] = await Promise.all([
          fetch(`https://apiaksharaconnect.aksharafinalytics.in/assignedtickets/${id}`),
          fetch(`https://apiaksharaconnect.aksharafinalytics.in/getemp/${id}`),
        ]);
        if (!employeeResponse.ok) {
          throw new Error('Failed to fetch employees');
        }
        // Parsing both responses
        const ticketResult = await ticketResponse.json();
        const employeeResult = await employeeResponse.json();
        
        setTickets(ticketResult.ticket || []);
        console.log(ticketResult);

        setEmployees(employeeResult.employee || []); // Set the employees data

      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // Initialize DataTable after tickets data is fetched
  useEffect(() => {
    if (tickets.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, 
        paging: true,
        pageLength: 10, 
        lengthMenu: [10, 25, 50, 100], 
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [tickets]);

  const exportToExcel = () => {
    if (tickets.length === 0) {
      alert("No data to export");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(tickets);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "tickets");

    XLSX.writeFile(wb, "Tickets_List.xlsx");
  };

  // Function to handle opening the modal and selecting a ticket
  const openUpdateStatusModal = (ticket) => {
    setSelectedTicket(ticket);
  };

  // Function to handle the form submission for updating status
  const handleUpdateStatus = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Get form data elements
    const { ticket_id, emp_query, status, file ,user_id} = e.target.elements;

    // Prepare FormData
    const formData = new FormData();
    formData.append('emp_query', emp_query.value);
    formData.append('status', status.value);
    formData.append('ticket_id', ticket_id.value);
    formData.append('user_id', user_id.value);

    // If there's a file selected, append it to FormData, otherwise append null (backend may handle this)
    if (file.files[0]) {
        formData.append('file', file.files[0]);
    } else {
        formData.append('file', '');  // Use an empty string to handle no file selection
    }

   

    try {
        const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/Tquery', {
            method: 'POST',
            body: formData,  
        });
        if (!response.ok) {
            throw new Error('Failed to update ticket');
        }

        const responseData = await response.json();      
        setSelectedTicket(null); 
        setSuccessMessage('Ticket status updated successfully'); 
        setTimeout(() => {
          setSuccessMessage(null);
          window.location.reload();
        }, 5000);
    } catch (error) {
        console.error('Error updating ticket:', error);
        setError("Somthing went worng");  // Clear any success message if there's an error
    } finally {
        // Close the modal or perform any clean-up after the API call
        setLoading(false);
    }
};

  const openTransferModal = (ticket) => {
    setTransferTicket(ticket); // Set the selected ticket for transfer
    setSelectedEmployee(''); // Reset employee selection
    setRemarks(''); // Reset remarks
  };

  // Function to handle ticket transfer
  const handleTransferTicket = async (e) => {
    e.preventDefault();
    setLoading(true);
    const transferData = {
      ticketId: transferTicket.id,
      emp_id: selectedEmployee,
      remarks: remarks,
    };

    try {
      console.log('Transfer Data:', transferData); // Log the data being sent
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/transferticket/${transferTicket.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(transferData),
      });

      if (!response.ok) {
        throw new Error(`Failed to transfer ticket, Status: ${response.status}`);
      }

      // Update the state with the new data
      setTickets(tickets.map(ticket =>
        ticket.id === transferTicket.id ? { ...ticket, status: 'Transferred' } : ticket
      ));

      setSelectedTicket(null); 
      setSuccessMessage('Ticket transferred successfully'); 
      setTimeout(() => {
        setSuccessMessage(null);
        window.location.reload();
      }, 5000);
    } catch (error) {
      console.error('Error transferring ticket:', error);
      setError("Somthing went worng"); 
    } finally {
      // Close the modal or perform any clean-up after the API call
      setLoading(false);
  }
};


  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      
      <div className="shadow mx-1 px-3 bg-light rounded-3">
        <div className="d-flex align-items-center justify-content-between p-3 mt-3">
          <h4 className="mb-0">Assigned Tickets</h4>
          <button className="btn btn-success" onClick={exportToExcel}>
            Export to Excel
          </button>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}
        <div className="card">
          <div className="card-header">Tickets Assigned</div>
          <div className="card-body">
            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped table-bordered display nowrap"
                style={{ width: '100%' }}
              >
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Ticket Id</th>
                    <th>User</th>
                    <th>Subject</th>
                    <th>Description</th>
                    <th>File</th>
                    <th>Transfer To</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {tickets.length > 0 ? (
                     tickets.map((ticket, index) => (
                    <tr key={ticket.id}>
                      <td>{index + 1}</td>
                      <td className="text-danger">{ticket.ticket_id || 'N/A'}</td>
                      <td className="text-primary">{ticket.Username || 'N/A'}</td>
                      <td>{ticket.Subject || 'N/A'}</td>
                      <td>{ticket.Description || 'N/A'}</td>
                      <td>
                        {ticket.emp_file ? (
                          <a href={`https://apiaksharaconnect.aksharafinalytics.in/${ticket.emp_file}`} download={ticket.emp_file || 'N/A'}>
                            <button className="btn btn-warning ms-2 p-1 m-1">
                              <FontAwesomeIcon icon={faDownload} /> Download
                            </button>
                          </a>
                        ) : (
                          <span></span>
                        )}
                      </td>
                      <td className="text-primary">{ticket.TransferEmpName || 'N/A'}</td>
                      <td>{ticket.doa || 'N/A'}</td>
                      <td className={ticket.status === 'closed' ? 'text-danger' : 'text-primary'}>
                            {ticket.status || 'N/A'}
                        </td>
                      <td>
                        <button className="btn btn-info" onClick={() => openUpdateStatusModal(ticket)} disabled={ticket.emp_status === "Transfered" || ticket.status === "closed"}>
                          Update Status
                        </button>
                        <button className="btn btn-warning ms-2" onClick={() => openTransferModal(ticket)} disabled={ticket.emp_status === "Transfered" || ticket.status === "closed"  }>
                          Transfer Ticket
                        </button>
                      </td>
                      <td>
                          <button className="btn btn-primary" onClick={() => navigate(`/Tqueries/${ticket.ticket_id}`)}>
                              View
                          </button>
                        </td>
                    </tr>
                  ))) : (
                    <tr>
                      <td colSpan="11" className="text-center">No Tickets available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for updating ticket status */}
      {selectedTicket && (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }} aria-modal="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update Ticket Status</h5>
                <button type="button" className="btn-close" onClick={() => setSelectedTicket(null)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleUpdateStatus} >
                  <div className="mb-3">
                  <input type="hidden" className="form-control" name="ticket_id" defaultValue={selectedTicket.ticket_id || ''}/>
                  <input type="hidden" className="form-control" name="user_id" defaultValue={selectedTicket.user_id || ''}/>
                    <label className="form-label">Description</label>
                    <textarea className="form-control" name="emp_query" defaultValue={selectedTicket.emp_query || ''}></textarea>
                  </div>                  
                  <div className="mb-3">
                    <label className="form-label">Attach File</label>
                    <input type="file" className="form-control" name="file" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select className="form-select" name="status" required defaultValue={selectedTicket.status || ''}>
                    <option value="">Select Status</option>
                      <option value="in-progress">In Progress</option>
                      <option value="closed">Closed</option>
                    </select>
                  </div>
                  {/* <button type="submit" className="btn btn-primary"  disabled={isSubmitting}>Save Changes</button> */}
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          updating...
                        </>
                      ) : (
                        'update'
                      )}
                    </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for transferring ticket */}
      {transferTicket && (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }} aria-modal="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Transfer Ticket</h5>
                <button type="button" className="btn-close" onClick={() => setTransferTicket(null)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleTransferTicket}>
                  <div className="mb-3">
                    <label className="form-label">Select Employee</label>
                    <select
                      className="form-select"
                      value={selectedEmployee}
                      onChange={(e) => setSelectedEmployee(e.target.value)}
                    >
                      <option value="">Select Employee</option>
                      {employees.map((employee) => (
                        <option key={employee.id} value={employee.id}>
                          {employee.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Remarks</label>
                    <textarea
                      className="form-control"
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                      placeholder="Enter remarks for the transfer"
                    ></textarea>
                  </div>

                  {/* <button type="submit" className="btn btn-primary">Transfer Ticket</button> */}
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Transferring...
                        </>
                      ) : (
                        'Transfer Ticket'
                      )}
                    </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssigningTickets;
